var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavFinanzas = function SvgNavFinanzas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_finanzas_svg__Capa_2",
    viewBox: "0 0 33.94 33.94"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_finanzas_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 33.25h-6.57c-7.18 0-13-5.82-13-13v-6.57C.69 6.51 6.51.69 13.69.69h6.57c7.18 0 13 5.82 13 13v6.57c0 7.18-5.82 13-13 13Z",
    stroke: "#b3b3b3",
    strokeWidth: "1.37px",
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.11 11.32c-.84-.53-8.3-2.74-8.79 2.01-.25 2.41 2.43 2.91 4.76 3.34s4.84 1.04 4.53 3.68c-.59 5.03-8.43 2.32-9.3 1.72M16.97 6.92v19.67",
    fill: "none",
    strokeLinecap: "round",
    stroke: "#19d3c5",
    strokeWidth: "1.5px"
  }))));
};
export default SvgNavFinanzas;